/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var PersonRemoveFillIcon = function PersonRemoveFillIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40804_16801)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "7",
    r: "4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12C8.16424 12 4.99542 14.2877 3.94514 17.3266L3.61849 18.2718L1.7282 17.6185L2.05485 16.6733C3.40829 12.7572 7.38932 9.99998 12 9.99998C14.166 9.99998 16.1858 10.6063 17.8611 11.6516L18.7095 12.1809L17.6509 13.8777L16.8025 13.3484C15.4444 12.5011 13.7914 12 12 12ZM18 16.5858L20.1213 14.4645L21.5355 15.8787L19.4142 18L21.5355 20.1213L20.1213 21.5355L18 19.4142L15.8787 21.5355L14.4645 20.1213L16.5858 18L14.4645 15.8786L15.8787 14.4644L18 16.5858Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40804_16801"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24"
  }))));
};
export default PersonRemoveFillIcon;